export default __webpack_public_path__ + "static/media/1X2-mono.d1453811.svg";